
import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Building, Clock, Users } from 'lucide-react';

interface TeachersFilterProps {
  currentFilter: string;
  onFilterChange: (filter: string) => void;
}

export const TeachersFilter: React.FC<TeachersFilterProps> = ({ 
  currentFilter, 
  onFilterChange 
}) => {
  const filters = [
    { id: 'all', label: 'All Teachers', icon: <Users className="h-4 w-4 mr-2" /> },
    { id: 'full-time', label: 'Full-time', icon: <Clock className="h-4 w-4 mr-2" /> },
    { id: 'part-time', label: 'Part-time', icon: <Clock className="h-4 w-4 mr-2" /> },
    { id: 'science', label: 'Science Dept.', icon: <Building className="h-4 w-4 mr-2" /> },
    { id: 'mathematics', label: 'Math Dept.', icon: <Building className="h-4 w-4 mr-2" /> },
    { id: 'humanities', label: 'Humanities', icon: <Building className="h-4 w-4 mr-2" /> }
  ];

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {filters.map((filter) => (
        <Button
          key={filter.id}
          size="sm"
          variant={currentFilter === filter.id ? "default" : "outline"}
          className={cn(
            "flex items-center",
            currentFilter === filter.id 
              ? "" 
              : "text-gray-600 hover:text-primary"
          )}
          onClick={() => onFilterChange(filter.id)}
        >
          {filter.icon}
          {filter.label}
        </Button>
      ))}
    </div>
  );
};
